// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"StarshopPurchaseModal_buttonContainer__cj1Dk","confirmText":"StarshopPurchaseModal_confirmText__1DT2z","buttonSpace":"StarshopPurchaseModal_buttonSpace__36tAB"};